/*
 * Bwè Manjé is a restaurant table booking application on the Android Platform.
 *
 * Copyright (C) 2020-2025 by Frédéric-Charles Barthéléry.
 *
 * This file is part of Bwè Manjé.
 */
package com.geekorum.rdv.bwemanje.accountdeletion

import androidx.compose.runtime.Composable
import androidx.compose.runtime.Composition
import androidx.compose.runtime.CompositionLocalProvider
import com.geekorum.rdv.bwemanje.accountdeletion.compose.viewmodel.LocalViewModelStoreOwner
import com.geekorum.rdv.bwemanje.accountdeletion.compose.viewmodel.ViewModelStore
import com.geekorum.rdv.bwemanje.accountdeletion.compose.viewmodel.ViewModelStoreOwner
import firebase.app.FirebaseApp
import firebase.app.initializeApp
import kotlinx.browser.document
import kotlinx.js.jso
import org.jetbrains.compose.web.dom.DOMScope
import org.w3c.dom.Element

//private val FIREBASE_CONFIG = js("process.env.FIREBASE_CONFIG")
private val STAGING_FIREBASE_CONFIG = jso<dynamic> {
    apiKey = "AIzaSyBIyN43tEEDjbKQ1xZFgRIDITI5syVGwKU"
    authDomain = "rdv-food.firebaseapp.com"
    databaseURL = "https://rdv-food.firebaseio.com"
    projectId = "rdv-food"
    storageBucket = "rdv-food.appspot.com"
    messagingSenderId = "890635930152"
    appId =  "1:890635930152:web:1edba166e4ebb87cebc31d"
    measurementId = "G-DN2YJNN8BK"
}

private val ViewModelStoreOwner = object : ViewModelStoreOwner {
    override val viewModelStore: ViewModelStore = ViewModelStore()
}

private fun <TElement : Element> renderComposable(
    root: TElement,
    content: @Composable DOMScope<TElement>.() -> Unit
): Composition {
    return org.jetbrains.compose.web.renderComposable(root) {
        CompositionLocalProvider(
            LocalViewModelStoreOwner provides ViewModelStoreOwner
        ) {
            content()
        }
    }
}

fun main() {
    val root = document.getElementById("root")

    renderComposable(root!!) {
        AccountDeletionPage(initializeApp(STAGING_FIREBASE_CONFIG))
    }
}

fun renderAccountDeletionPage(root: Element, firebaseApp: FirebaseApp) {
    renderComposable(root) {
        AccountDeletionPage(firebaseApp)
    }
}
